<template>
  <div class="TimelineRoot__wrapper">
    <div class="TimelineRoot">
      <slot />
      <div class="side-border"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
  @import '@/assets/styles/variables';

  .TimelineRoot__wrapper {
    z-index: 0;
    .TimelineRoot {
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 0.5rem 1rem;
      position: relative;

      .side-border {
        position: absolute;
        height: 100%;
        z-index: -1;
        left: 1rem;
        width: 1px;
        justify-self: center;
        background-image: linear-gradient($neutral-gray 33%, rgba(255, 255, 255, 0) 0%);
        background-size: 1px 10px;
      }
    }
  }
</style>
